// Copyright (C) Microsoft Corporation. All rights reserved.

import { isAadUser, isUserAuthenticated } from "../Common/Helpers";
import { addSilentAuthEventListener } from "../Common/Auth/AuthHelpers";
import { SilentSignInProperties } from '../Common/AuthenticationTypes';

let $downloadButton = $('#smbOfficeDownload');

export function LoadSmbDownload() {
	const analytics = window.analytics;

	$downloadButton.on('click', async function () {
		if ($downloadButton.attr('href') === '#') {
			const { productId, url } = await getOfficeDownload();
			if (url) {
				window.location.href = url;
			}

			if (analytics) {
				analytics.captureContentUpdate(null, {
					isAuto: false,
					behavior: window.oneDS.Behavior.OTHER,
					content: {
						'contentId': `${$downloadButton.attr('id')}_productDetail`,
						'contentName': $downloadButton.text(),
						'contentType': 'anchor',
						'compnm': 'cta-link',
						'product': productId
					}
				});
			}
		}
	});
}

async function getOfficeDownload(): Promise<{ productId: string, url: string }> {
	let result: Response;
	try {
		result = await fetch('/officedownload', {
			method: 'GET',
		});
		const data = await result.json();
		return { productId: data.ProductId, url: data.Url };
	} catch (error) {
		console.error('Get installer download link failed, error: ' + error);
		return { url: '', productId: '' };
	}
}

addSilentAuthEventListener((props: CustomEvent<SilentSignInProperties | Error>) => {
	if (props.detail instanceof Error) {
		return;
	}

	const authProperties = props.detail as SilentSignInProperties;
	const isUserAuthed = isUserAuthenticated(authProperties.authType);
	const isUserAad = isAadUser(authProperties.authType);

	if (isUserAuthed && isUserAad) {
		$("#smbOfficeDownload").attr("href", "#");
	}
})
